import { Swiper } from './swiper';

const homepageSwiper = new Swiper('.homepage-slider__container', {
    loop: true,
    navigation: {
        nextEl: ".homepage-slider-next",
        prevEl: ".homepage-slider-prev",
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
});
